import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Paper
} from '@mui/material';
import {
  Info,
  CheckCircle
} from '@mui/icons-material';

const TestInstructions: React.FC = () => {
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Info sx={{ color: 'primary.main', mr: 1 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Test Instructions
          </Typography>
        </Box>
        
        <List dense sx={{ flexGrow: 1 }}>
          <ListItem>
            <ListItemIcon>
              <CheckCircle sx={{ fontSize: 20, color: 'success.main' }} />
            </ListItemIcon>
            <ListItemText 
              primary="Read each question carefully"
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </ListItem>
          
          <ListItem>
            <ListItemIcon>
              <CheckCircle sx={{ fontSize: 20, color: 'success.main' }} />
            </ListItemIcon>
            <ListItemText 
              primary="You can navigate between questions"
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </ListItem>
          
          <ListItem>
            <ListItemIcon>
              <CheckCircle sx={{ fontSize: 20, color: 'success.main' }} />
            </ListItemIcon>
            <ListItemText 
              primary="Mark questions for review"
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </ListItem>
          
          <ListItem>
            <ListItemIcon>
              <CheckCircle sx={{ fontSize: 20, color: 'success.main' }} />
            </ListItemIcon>
            <ListItemText 
              primary="Submit before time expires"
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </ListItem>
          
          <ListItem>
            <ListItemIcon>
              <CheckCircle sx={{ fontSize: 20, color: 'success.main' }} />
            </ListItemIcon>
            <ListItemText 
              primary="No negative marking"
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </ListItem>
        </List>

        <Divider sx={{ my: 2 }} />
        
        <Paper sx={{ p: 2, bgcolor: '#f8f9fa', mt: 'auto' }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            <strong>Important:</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Ensure stable internet connection. The test will auto-submit when time expires.
          </Typography>
        </Paper>
      </CardContent>
    </Card>
  );
};

export default TestInstructions;